"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PercentSqliteHandler", {
    enumerable: true,
    get: function() {
        return PercentSqliteHandler;
    }
});
const _decimalsqlitehandler = require("~/db/field-handler/handlers/decimal/decimal.sqlite.handler");
let PercentSqliteHandler = class PercentSqliteHandler extends _decimalsqlitehandler.DecimalSqliteHandler {
};
